import React, { useContext, useEffect, useRef, useState } from "react";
import cartSInfo from "./AddToCart.module.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import BookInfo from "../BookModule.module.css";
import OrderSuccessNote from "../OrderSuccessNote";
import { CurrencyRupee } from "@mui/icons-material";
import CourierDetails from "../CourierDetails";
import PickUpDetails from "../PickUpDetails";
import CardTemplate from "../CardTemplate";
import PreOrderNote from "../PreOrderNote";
import Loader from "../../../Loader";
import { AxiosInstance } from "../../../../../axios";
import toast from "react-hot-toast";
import moment from "moment";
import PdfImage from "../pdf.png";
import { ImageUrlPrefix, BookPaymentSKey, R_PER_PAGE } from "../../../../../labels";
import PaginationTop10 from "../../../../../pages/dashboard/PaginationTop10";
import { Dialog, DialogContent } from "@mui/material";
import { CartContext } from "../../../../../context/CartItems";
import { WishListContext } from "../../../../../context/WishListItems";
import BookReviewModal from "../../StudentTestWorkflow/BookReviewModal";
import { Modal } from "react-bootstrap";
export default function CartSuccess() {
  const { tabLabel } = useParams();
  const location = useLocation();
  const {
    purchase_id,
    order_id,
    PAYMENT_MODE,
    PAYMENT_STATUS,
    DELIVERY_MODE,
    DELIVERY_STATUS,
    SEACRHTERM,
  } = location.state || {};

  const navigate = useNavigate();
  const navigateToPreviousScreen = () => {
    // navigate(-1);
    navigate("/TransactionHistory/3", {
      state: {
        filPayment_mode: PAYMENT_MODE,
        filPayment_status: PAYMENT_STATUS,
        fildelivery_mode: DELIVERY_MODE,
        fildelivery_status: DELIVERY_STATUS,
        filter_search: SEACRHTERM,
      },
    });
  };
  const { cartNotify } = useContext(CartContext);
  const { WishNotify } = useContext(WishListContext);
  const navigatebooks = () => {
    navigate("/studyMaterials/Books/ViewAllBook");
  };
  let BooksPerPageforWidgets = 4;
  const [listErrors, setListErrors] = useState({});
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const [flagReload, setFlagReload] = useState(false);
  const [booksetIndex, setBooksetIndex] = useState(0);
  const [list, setList] = useState({
    Verify: false,
  });
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  const txtadVerifyHere = useRef(null);
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("UserId Not available");
  }

  const [isLoading, setIsLoading] = useState(false);
  const [fdata, setFdata] = useState([]);
  const [isEbook, setIsEbook] = useState(false);
  const [transStatus, setTransStatus] = useState(5);
  const [isBookSet, setIsBookSet] = useState(false);
  const [preorderdata, setPreorderdata] = useState([]);
  const [paymentDedata, setPaymentDedata] = useState([]);

  const [deliverydata, setDeliverydata] = useState([]);
  const [courierDetdata, setCourierDetdata] = useState([]);
  const [pickupDdata, setPickupDdata] = useState([]);
  useEffect(() => {
    vIEWbYid();
  }, [tabLabel, flagReload]);
  const handleChange = (event) => {
    const { name, value, files, checked } = event.target;
    if (name == "Verify") {
      setList((prevList) => ({
        ...prevList,
        [name]: checked,
      }));
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    } else {
      setList({
        ...list,
        [name]: value,
      });
      setListErrors({
        ...listErrors,
        [name]: "",
      });
    }
  };
  function vIEWbYid() {
    let statusFilter = {
      user_id: userid,
      id: purchase_id,
      transaction_order_id: order_id,
    };
    setIsLoading(true);
    AxiosInstance.post("api/book/purchase/view_by_student", statusFilter)
      .then((res) => {
        if (res.data.status === true && res.data.transaction_status == 4) {
          setIsLoading(false);
          setTransStatus(4);
          toast.success(res.data.message);
          navigateToPreviousScreen();
        } else if (
          res.data.status === true &&
          res.data.transaction_status !== "" &&
          res.data.transaction_status == 0
        ) {
          setTransStatus(0);
          const Datt = res?.data?.data;
          const booksetStatus = res?.data?.data.some((io) => io.is_set === 1);
          const shippingaddress = res?.data?.shipping_address;
          const paymentdetails = res?.data?.payment_details;
          const preorderitems = res?.data?.pre_order_items;
          const CouDet =
            shippingaddress.delivery_mode === 1
              ? res?.data?.courier_details
                ? res?.data?.courier_details
                : []
              : [];
          const PickDet =
            shippingaddress.delivery_mode === 0
              ? res?.data?.courier_details
                ? res?.data?.courier_details
                : []
              : [];
          setFdata(Datt);
          setIsEbook(Datt.every((book) => book.is_ebook === 1));
          setDeliverydata(shippingaddress);
          setCourierDetdata(CouDet);
          setPickupDdata(PickDet);
          setPreorderdata(preorderitems);
          setPaymentDedata(paymentdetails);
          setIsLoading(false);
          setIsBookSet(booksetStatus);
        } else if (
          res.data.status === true &&
          res.data.transaction_status == ""
        ) {
          setTransStatus("");
          const Datt = res?.data?.data;
          const booksetStatus = res?.data?.data.some((io) => io.is_set === 1);
          setIsBookSet(booksetStatus);
          const shippingaddress = res?.data?.shipping_address;
          const paymentdetails = res?.data?.payment_details;
          const preorderitems = res?.data?.pre_order_items;
          const CouDet =
            shippingaddress.delivery_mode === 1
              ? res?.data?.courier_details
                ? res?.data?.courier_details
                : []
              : [];
          const PickDet =
            shippingaddress.delivery_mode === 0
              ? res?.data?.courier_details
                ? res?.data?.courier_details
                : []
              : [];
          setFdata(Datt);
          setIsEbook(Datt.every((book) => book.is_ebook === 1));
          setDeliverydata(shippingaddress);
          setCourierDetdata(CouDet);
          setPickupDdata(PickDet);
          setPreorderdata(preorderitems);
          setPaymentDedata(paymentdetails);
          setIsLoading(false);
        } else if (res.data.status === false) {
          setIsLoading(false);
          setIsEbook(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  }
  const [updateListData, setUpdateListData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const firstHalf = updateListData.slice();
  const secondHalf = updateListData.slice();
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  useEffect(() => {
    loadListData();
  }, []);

  const loadListData = async () => {
    setIsLoading(true);
    try {
      const res = await AxiosInstance.post(`/api/book/courier/list`);
      if (res.status === 200 && Array.isArray(res.data.data)) {
        setUpdateListData(res.data.data);
      } else {
        setUpdateListData([]);
      }
    } catch (error) {
      console.error("Error loading data:", error);
      setUpdateListData([]);
    }
    setIsLoading(false);
  };
  // prev button pagination
  const handlePrev_bookset = (val) => {
    if (val >= 0) {
      setBooksetIndex(val);
      window.scrollTo({ top: "1350", behavior: "smooth" }); // Scroll to top
    }
  };
  // next button pagination
  const handleNext_bookset = (val) => {
    if (val < 5 && preorderdata[booksetIndex]) {
      setBooksetIndex(val);
      window.scrollTo({ top: "1350", behavior: "smooth" }); // Scroll to top
    }
  };

  const addWishList = (idsBook, is_fav) => {
    AxiosInstance.post("api/book/wishlist/add", {
      user_id: userid,
      book_id: idsBook,
      is_favorite: is_fav == 1 ? 0 : 1,
      created_dt: moment().format("YYYY-MM-DD"),
      created_by: userid,
    })
      .then((res) => {
        if (res.data.status) {
          toast.success(res.data.message);
          setFlagReload(!flagReload);
          WishNotify(userid);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((error) => {
        return error;
      });
  };

  // add to cart function
  const handleCartPage = (idss) => {
    AxiosInstance.post("/api/book/cart/add", {
      id: "",
      user_id: userid,
      book_id: idss,
      created_dt: moment().format("YYYY-MM-DD"),
      created_by: userid,
    })
      .then((res) => {
        if (res.data.status) {
          toast.success(res.data.message);
          setFlagReload(true);
          cartNotify(userid);
        } else {
          toast.error(res.data.message);
          setFlagReload(true);
        }
      })
      .catch((error) => {
        return error;
      });
  };
  const handlesubmit = () => {
    if (list.Verify === true) {
      if (userid) {
        const ActFees = paymentDedata[0]?.total_amount?.toFixed(2);
        const receipt = "Order_" + userid;
        AxiosInstance.post("api/book/create_order", {
          amount: parseInt(ActFees * 100),
          currency: "INR",
          receipt: receipt,
        })
          .then((res) => {
            if (res.data.status) {
              const { data } = res;
              let payment_status = "";

              if (data.status === "failed") {
                payment_status = 0;
              } else if (data.status === "created") {
                payment_status = 1;
              } else if (data.status === "authenticated") {
                payment_status = 2;
              } else if (data.status === "authorized") {
                payment_status = 3;
              } else if (data.status === "captured") {
                payment_status = 4;
              } else if (data.status === "refunded") {
                payment_status = 5;
              }
              setIsPaymentLoading(true);
              const dat = {
                id: paymentDedata[0]?.id,
                user_id: userid,
                shipping_type: paymentDedata[0]?.shipping_type,
                shipping_address_pk: paymentDedata[0]?.shipping_address_pk,
                payment_mode: paymentDedata[0]?.payment_mode,
                actual_price: paymentDedata[0].actual_price,
                special_offer: paymentDedata[0]?.special_offer,
                coupon_code: paymentDedata[0]?.coupon_code,
                coupon_amount: paymentDedata[0]?.coupon_amount,
                reward_used: paymentDedata[0]?.reward_amount > 0 ? 1 : 0,
                reward_amount: paymentDedata[0]?.reward_amount,
                total_discount: paymentDedata[0]?.total_discount,
                courier_charge: paymentDedata[0]?.courier_charge,
                total_amount: paymentDedata[0]?.total_amount,
                transaction_status: payment_status,
                transaction_order_id: data.id,
                cart_id: fdata?.map((item) => item.id),
                created_dt: moment
                  .unix(data.created_at)
                  .format("YYYY-MM-DD HH:mm:ss"),
                created_by: userid,
                items: fdata?.map((item) => {
                  return {
                    book_id: item.id,
                    quantity: item.quantity,
                    is_set: item.is_set,
                  };
                }),
              };
              AxiosInstance.post("api/book/orders", dat)
                .then((res) => {
                  const responseData = res.data;

                  if (responseData.status === true) {
                    console.log("✅ Order API success:", responseData.status);

                    setIsPaymentLoading(false);
                    const options = {
                      key: BookPaymentSKey,
                      amount: res.data.data.total_amount,
                      currency: "INR",
                      order_id: res.data.data.transaction_order_id,
                      handler: function (response) {
                        if (response) {
                          setIsPaymentLoading(true);
                          const dats = {
                            user_id: userid,
                            id: res?.data?.data?.id,
                            shipping_type: res.data.data.shipping_type,
                            shipping_address_pk:
                              res.data.data.shipping_address_pk,
                            payment_mode: res.data.data.payment_mode,
                            actual_price: res.data.data.actual_price,
                            special_offer: res.data.data.special_offer,
                            coupon_code: res.data.data.coupon_code,
                            coupon_amount: res.data.data.coupon_amount,
                            reward_used:
                              res.data.data.reward_amount > 0 ? 1 : 0,
                            reward_amount: res.data.data.reward_amount,
                            total_discount: res.data.data.total_discount,
                            courier_charge: res.data.data.courier_charge,
                            total_amount: res.data.data.total_amount,
                            transaction_status:
                              res.data.data.transaction_status,
                            transaction_order_id:
                              res.data.data.transaction_order_id,
                            cart_id: res.data.data.cart_id,
                            created_dt: moment(res.data.created_at).format(
                              "YYYY-MM-DD HH:mm:ss"
                            ),
                            created_by: userid,
                            items: res.data.data.items?.map((item) => {
                              return {
                                book_id: item.book_id,
                                quantity: item.quantity,
                                is_set: item.is_set,
                              };
                            }),
                          };

                          AxiosInstance.post("api/book/purchase", dats)
                            .then((res) => {
                              if (res.data.status === true) {
                                setIsPaymentLoading(false);
                                navigate("/TransactionHistory/3");
                                toast.success(res.data.message);
                              } else {
                                setIsPaymentLoading(false);
                                toast.error(res.data.message);
                              }
                            })
                            .catch((error) => {
                              setIsPaymentLoading(false);
                              toast.error(error.message || "An error occurred");
                              return error;
                            });
                        } else {
                          setIsPaymentLoading(false);
                          toast.error(res.data.message);
                        }
                      },
                      modal: {
                        ondismiss: function () {
                          // Triggered when the Razorpay modal is closed by the user
                          navigate("/TransactionHistory/3"); // book tab for payment pending
                        },
                      },
                    };
                    // setStepperButton(false);
                    const rzp1 = new window.Razorpay(options);
                    rzp1.open();
                    setIsPaymentLoading(false);
                  } else {
                    setIsPaymentLoading(false);
                    toast.error(res.data.message);
                  }
                })
                .catch((error) => {
                  setIsPaymentLoading(false);
                  toast.error(error.message || "An error occurred");
                  return error;
                });
            } else {
              setIsPaymentLoading(false);
              toast.error(res.data.message);
            }
          })
          .catch((error) => {
            setIsPaymentLoading(false);
            toast.error(error.message || "An error occurred");
            return error;
          });
      } else {
        setIsPaymentLoading(false);
        console.log("User Id cannot avaliable in session storage");
      }
    } else {
      setIsPaymentLoading(false);
      let err = "Please look and verify the Terms and Conditions.";
      txtadVerifyHere.current.focus();
      setListErrors({
        ...listErrors,
        Verify: err,
      });
    }
  };

  const totalPreOrderD =
    preorderdata.length > 0 ? preorderdata?.slice(-12) : [];
  const preorderdataD =
    totalPreOrderD.length > 0
      ? totalPreOrderD.slice(
          booksetIndex * BooksPerPageforWidgets,
          (booksetIndex + 1) * BooksPerPageforWidgets
        )
      : [];

  const deliverydate = moment(paymentDedata[0]?.created_dt, "YYYY-MM-DD")
    .add(7, "days")
    .format("DD/MM/YYYY");

  const [open, setOpen] = useState(false);
  const [selectedBookId, setSelectedBookId] = useState();
  const handleModelOpen = (io) => {
    setSelectedBookId(io.id);
    setOpen(true);
  };
  const handleModelClose = () => {
    setOpen(false);
  };
  const [hide, setHide] = useState(null);
  const handleDownload = (id, orderId) => {
    const downloadData = {
      order_id: orderId,
      book_id: id,
    };
    AxiosInstance.post("api/book/e_book_download", downloadData)
      .then((res) => {
        if (res.data.status) {
          setHide(res.data.data);
          setFdata((prevFdata) =>
            prevFdata.map((item) =>
              item.id === id ? { ...item, is_downloaded: 1 } : item
            )
          );
          window.open(res.data.data, "_blank");
        } else {
        }
      })
      .catch((error) => {
        return error;
      });
  };
  const handleViewAbooksnav = (book_id) => {
    navigate(`/ViewBook/${book_id}`);
  };
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <>
      {open && (
        <BookReviewModal
          type="1"
          selectedBookId={selectedBookId}
          open={open}
          setOpen={setOpen}
          handleModelOpen={handleModelOpen}
          handleModelClose={handleModelClose}
          cancelLable={
            tabLabel == 1 ? "View Transaction History" : "Payment Successful"
          }
        />
      )}

      <div
        className={`${cartSInfo.CourseInfoSec}  container-fluid global_container BathHeader`}
      >
        {transStatus === "" && (
          <div className="row mx-0">
            <div className="col-md-6 col-12 ps-0">
              <h2 className="TitleHeader">
                {tabLabel == 1
                  ? "View Transaction History"
                  : "Payment Successful"}
              </h2>
              {/* View Book Transaction History */}
            </div>
            <div className="col-md-6 col-12 ListBtn px-0">
              <ul class="List-Button">
                <li class="ListBtnItems">
                  <Link
                    to={"javascript:void(0)"}
                    onClick={
                      tabLabel == 1 ? navigateToPreviousScreen : navigatebooks
                    }
                    className="secondaryButton me-0 px-0"
                    variant="secondary"
                  >
                    {tabLabel == 1
                      ? "Back to Transaction History"
                      : "Back to View All Books"}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        )}

        {transStatus === 0 && (
          <div className="row mx-0 mb-2">
            <div className="col-md-6 col-12 ps-0">
              <h2 className="TitleHeader">View Transaction History</h2>
              {/* View Book Transaction History */}
            </div>
            <div className="col-md-6 col-12 ListBtn px-0">
              <ul class="List-Button">
                <li class="ListBtnItems">
                  <Link
                    to={"javascript:void(0)"}
                    onClick={
                      tabLabel == 1 ? navigateToPreviousScreen : navigatebooks
                    }
                    className="secondaryButton me-0 px-0"
                    variant="secondary"
                  >
                    {tabLabel == 1
                      ? "Back to Transaction History"
                      : "Back to View All Books"}
                  </Link>
                </li>
                <li class="ListBtnItems">
                  <Link
                    onClick={handlesubmit}
                    to="javascript:void(0)"
                    className="primaryButton "
                  >
                    Proceed To Payment Gateway
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        )}
        {tabLabel == 0 && transStatus === "" && (
          <div className="row mx-0 mt-3 mb-3">
            <div className="col-md-12 col-lg-12 col-12 px-0">
              <OrderSuccessNote
                ExpectedDate={deliverydate}
                deliveryMode={deliverydata.delivery_mode}
              />
            </div>
          </div>
        )}

        {isBookSet && preorderdata.length > 0 && (
          <div className="row mx-0">
            <div className="col-md-12 col-lg-12 col-12 px-0 ">
              <PreOrderNote preOrderdata={preorderdata} />
            </div>
          </div>
        )}

        <div className="row ">
          <div className="col-lg-8 mt-3">
            <fieldset>
              <legend className="w-auto">Book Details</legend>
              {fdata.length > 0 ? (
                fdata.map((io, ind) => (
                  <div className="card p-3 mb-3" key={ind}>
                    <div className="row">
                      {/* col - 1 */}
                      <div
                        className={`${cartSInfo.margin_top} col-lg-3 d-flex justify-content-center justify-content-lg-start`}
                        style={{ cursor: "pointer" }}
                        onClick={() => handleViewAbooksnav(io.id)}
                      >
                        {/* {io.is_ebook == 1 ? (
                          <img
                            src={PdfImage}
                            className={`${cartSInfo.course_img} mb-2`}
                            alt=""
                          />
                        ) : ( */}
                        <img
                          src={
                            io.images[0]
                              ? `${ImageUrlPrefix}/${io.images[0]?.book_image_path}`
                              : PdfImage
                          }
                          className={`${cartSInfo.course_img} mb-2`}
                          alt=""
                        />
                        {/* )} */}
                      </div>
                      {/* col - 2*/}
                      <div className="col-lg-5">
                        <div className="d-flex flex-column">
                          <p
                            className={`${BookInfo.ellipsis_book} confirm_value my-1 m-0 p-0`}
                            style={{ cursor: "pointer" }}
                            onClick={() => handleViewAbooksnav(io.id)}
                          >
                            {io.is_set == 1
                              ? io.book_title
                                ? `${io.book_title} ${
                                    io.no_of_books
                                      ? ` (Set of ${io.no_of_books} Books)`
                                      : ""
                                  }`
                                : ""
                              : io.book_title
                              ? io.book_title
                              : ""}
                          </p>
                          <p
                            className={`${BookInfo.BookSubTitle} ${BookInfo.ellipsis_book} mb-1 m-0 p-0`}
                          >
                            {io.author}
                          </p>
                        </div>
                        {/* 2 */}
                        <div className={`${cartSInfo.BookborderRed}`}>
                          <p className={` my-1`}>
                            <span className={BookInfo.item_price}>
                              <CurrencyRupee className={BookInfo.rupees_icon} />
                              {io.finalPrice}
                            </span>
                            <span className={BookInfo.item_price_disAmount}>
                              {io.price}
                            </span>
                            <span className={BookInfo.item_price_offer}>
                              {io.offer_percentage}% off
                            </span>
                            {io.is_ebook === 1 ? (
                              <span
                                className={`${BookInfo.stock_item_right_label} ms-3 mb-0`}
                              >
                                E-Book
                              </span>
                            ) : null}
                            {/* 
                          {io.stock_count === 0 &&
                            io.is_set == 0 &&
                            io.is_ebook == 0 ? (
                            <span
                              className={`${BookInfo.stock_item_right_label} ms-3 mb-0`}
                            >
                              Out of Stock
                            </span>
                          ) : io.stock_count > 0 &&
                            io.stock_count < 10 &&
                            io.is_set == 0 &&
                            io.is_ebook == 0 ? (
                            <span
                              className={`${BookInfo.stock_item_right_label} ms-3 mb-0`}
                            >
                              {`Only ${io.stock_count} ${io.stock_count > 1 ? `Items` : `Item`
                                } Left`}
                            </span>
                          ) : (
                            ""
                          )} */}
                          </p>
                        </div>
                        <div className="row">
                          {io.dimension !== null && (
                            <div className="my-1 col-lg-6 col-md-6 col-12">
                              <div className="d-flex flex-column">
                                <p className="confirm_label m-0 p-0">
                                  Dimension
                                </p>
                                <p className="confirm_value my-1 m-0 p-0">
                                  {`${io.dimension} CM`}
                                </p>
                              </div>
                            </div>
                          )}
                          {io.weight !== null && (
                            <div className="my-1 col-lg-6 col-md-6 col-12">
                              <div className="d-flex flex-column">
                                <p className="confirm_label m-0 p-0">Weight</p>
                                <p className="confirm_value my-1 m-0 p-0">
                                  {`${io.weight} KG`}
                                </p>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        className={`${cartSInfo.margin_top} col-lg-4 ListBtn`}
                      >
                        <div className="forms ">
                          <div className="d-flex py-2 px-3 justify-content-center justify-content-lg-end">
                            <>
                              <input
                                style={{
                                  width: "100px",
                                  marginLeft: "5px",
                                  opacity: 0.7,
                                  textAlign: "center",
                                  cursor: "default",
                                }}
                                type="text"
                                disabled
                                class="Inputs"
                                id="NModelExam"
                                value={io.quantity}
                              />
                              <br />
                            </>
                          </div>

                          {/* <div style={{ textAlign: "end" }}>
                         
                          </div> */}
                        </div>
                      </div>
                    </div>
                    <div className="">
                      <ul class="List-Button ">
                        <li class="ListBtnItems">
                          <Link
                            onClick={() => handleModelOpen(io)}
                            to="javascript:void(0)"
                            className="primaryButton "
                            variant="primary"
                          >
                            Write a Review
                          </Link>
                        </li>
                        {io.is_downloaded == 0 &&
                          paymentDedata[0]?.transaction_status == 4 &&
                          io.is_ebook == 1 && (
                            <li class="ListBtnItems">
                              <Link
                                onClick={() =>
                                  handleDownload(io.id, paymentDedata[0].id)
                                }
                                to="javascript:void(0)"
                                className="primaryButton "
                                variant="primary"
                              >
                                Download this E-Book
                              </Link>
                            </li>
                            // <button
                            //   onClick={() =>
                            //     handleDownload(io.id, paymentDedata[0].id)
                            //   }
                            //   className="secondaryButton p-0"
                            //   style={{
                            //     border: "none",
                            //     background: "#fff",
                            //     fontSize: "13px",
                            //   }}
                            // >
                            //   <span title="You can download this PDF only once">
                            //     Download this E-Book
                            //   </span>
                            // </button>
                          )}
                      </ul>
                    </div>
                  </div>
                ))
              ) : (
                <div className="card p-3 mb-3">
                  <div className="row">
                    <div className="col-6 col-sm-5 col-lg-6 col-md-6 d-flex justify-content-end">
                      <p className="confirm_value">No Records</p>
                    </div>
                  </div>
                </div>
              )}
            </fieldset>
          </div>
          <div className="col-lg-4 mt-3">
            <fieldset>
              <legend className="w-auto">Payment Details</legend>
              {paymentDedata.length > 0 &&
                paymentDedata.map((sd, ind) => (
                  <div className="h-100" key={ind}>
                    {/* 1 */}
                    <div className="row mt-3">
                      <div className="col-6 col-sm-5 col-lg-6 col-md-6 d-flex justify-content-end">
                        <h6 className="confirm_value">Actual Price</h6>
                      </div>
                      <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                        <h6 className="confirm_value">
                          <CurrencyRupee
                            className={`${cartSInfo.payment_currency}`}
                          />

                          {sd.actual_price}
                        </h6>
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="row mt-3">
                      <div className="col-6 col-sm-5 col-lg-6 col-md-6 d-flex justify-content-end">
                        <h6 className="confirm_label">Special Offer</h6>
                      </div>
                      <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                        <h6 className="confirm_value">
                          <CurrencyRupee
                            className={`${cartSInfo.payment_currency}`}
                          />
                          {sd.special_offer}
                        </h6>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-6 col-sm-5 col-lg-6 col-md-6 d-flex justify-content-end">
                        <h6 className="confirm_label">Coupon Code Amount</h6>
                      </div>
                      <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                        <h6 className="confirm_value">
                          <CurrencyRupee
                            className={`${cartSInfo.payment_currency}`}
                          />
                          {sd.coupon_amount}
                        </h6>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-6 col-sm-5 col-lg-6 col-md-6 d-flex justify-content-end">
                        <h6 className="confirm_label">Reward Points Amount</h6>
                      </div>
                      <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                        <h6 className="confirm_value">
                          <CurrencyRupee
                            className={`${cartSInfo.payment_currency}`}
                          />
                          {sd.reward_amount}
                        </h6>
                      </div>
                    </div>
                    {/* 7  Total Discount*/}
                    <div className="row mt-3">
                      <div className="col-6 col-sm-5 col-lg-6 col-md-6 d-flex justify-content-end">
                        <h6 className="confirm_value">Total Discount</h6>
                      </div>
                      <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                        <h6 className="confirm_value">
                          <CurrencyRupee
                            className={`${cartSInfo.payment_currency}`}
                          />
                          {sd.total_discount}
                        </h6>
                      </div>
                    </div>
                    {/* Amount Payable */}
                    {deliverydata.delivery_mode == 1 && (
                      <div className="row mt-3">
                        <div className="col-6 col-sm-5 col-lg-6 col-md-6 d-flex justify-content-end">
                          <h6 className="confirm_value">Amount Payable</h6>
                        </div>
                        <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                          <h6 className="confirm_value">
                            <CurrencyRupee
                              className={`${cartSInfo.payment_currency}`}
                            />
                            {sd.actual_price -
                              (sd.special_offer +
                                sd.coupon_amount +
                                sd.reward_amount)}
                          </h6>
                        </div>
                      </div>
                    )}

                    {/* 8 courier */}

                    {deliverydata.delivery_mode == 1 && (
                      <div className="row mt-3">
                        <div className="col-6 col-sm-5 col-lg-6 col-md-6 d-flex justify-content-end">
                          <h6 className="confirm_label">Courier Charges</h6>
                          <span
                            id={cartSInfo.impo}
                            class="material-icons"
                            onClick={handleOpenModal}
                          >
                            error
                          </span>
                        </div>
                        {/* Modal Component */}
                        <Modal
                          show={showModal}
                          onHide={handleCloseModal}
                          centered
                          className="modal-lg"
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>
                              Courier Charges Information{" "}
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="container">
                              {updateListData
                                .filter((course) => course.isActive === 1)
                                .reduce((rows, course, index, all) => {
                                  if (index % 2 === 0) {
                                    rows.push([course]);
                                  } else {
                                    rows[rows.length - 1].push(course);
                                  }
                                  return rows;
                                }, [])
                                .map((pair, index) => (
                                  <div className={`col-12 `} key={index}>
                                    <div className="row">
                                      <div className="col-12 col-sm-6 px-4 mb-2">
                                        <div
                                          className={`${
                                            index % 2 === 0
                                              ? `${cartSInfo.bgOddColor}`
                                              : `${cartSInfo.bgEvenColor}`
                                          } row`}
                                        >
                                          <div className="col-3 p-0 text-end">
                                            {pair[0].start_gram_range} gms
                                          </div>
                                          <div className="col-1 p-0 text-end">
                                            {" "}
                                            to{" "}
                                          </div>
                                          <div className="col-3 p-0 text-end">
                                            {pair[0].end_gram_range} gms
                                          </div>
                                          <div className="col-2 p-0 text-end">
                                            -{" "}
                                          </div>
                                          <div className="col-2 offset-md-1 px-2 text-end">
                                            ₹{pair[0].amount}
                                          </div>
                                        </div>
                                      </div>

                                      {pair[1] && (
                                        <div className="col-12 col-sm-6 px-4 mb-2">
                                          <div
                                            className={`${
                                              index % 2 !== 0
                                                ? `${cartSInfo.bgOddColor}`
                                                : `${cartSInfo.bgEvenColor}`
                                            } row`}
                                          >
                                            <div className="col-3 p-0 text-end">
                                              {pair[1]?.start_gram_range} gms
                                            </div>
                                            <div className="col-1 p-0 text-end">
                                              {" "}
                                              to{" "}
                                            </div>
                                            <div className="col-3 p-0 text-end">
                                              {pair[1]?.end_gram_range} gms
                                            </div>
                                            <div className="col-2 p-0 text-end">
                                              -{" "}
                                            </div>
                                            <div className="col-2 offset-md-1 px-2 text-end">
                                              ₹{pair[1]?.amount}
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </Modal.Body>

                          <Modal.Footer>
                            <Link
                              variant="primary"
                              className="primaryButton"
                              onClick={handleCloseModal}
                            >
                              Close
                            </Link>
                          </Modal.Footer>
                        </Modal>
                        <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                          <h6 className="confirm_value">
                            <CurrencyRupee
                              className={`${cartSInfo.payment_currency}`}
                            />
                            {sd.courier_charge}
                          </h6>
                        </div>
                      </div>
                    )}

                    {/* 9 Net Amount */}
                    <div className="row mt-3">
                      <div className="col-6 col-sm-5 col-lg-6 col-md-6 d-flex justify-content-end">
                        <h6 className="confirm_value">
                          {transStatus === 0
                            ? "Net Amount To Pay"
                            : "Net Amount Paid"}
                        </h6>
                      </div>
                      <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                        <h6 className="confirm_value">
                          <CurrencyRupee
                            className={`${cartSInfo.payment_currency}`}
                          />
                          {sd.total_amount}
                        </h6>
                      </div>
                    </div>
                  </div>
                ))}
            </fieldset>
          </div>
        </div>
        {!isEbook && (
          <>
            <fieldset className="mt-3">
              <legend className="w-auto">
                {deliverydata.delivery_mode == 1
                  ? "Delivery Address"
                  : "Pickup Address"}
              </legend>
              <div className={`row mx-0 padding_10_0`}>
                <div className="my-1 px-0 col-lg-12 col-md-12 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">Delivery Mode</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {deliverydata.delivery_mode == 1
                        ? "Courier Delivery"
                        : "Collect at Branch"}
                    </p>
                  </div>
                </div>
                <div className="my-1 px-0 col-lg-12 col-md-12 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">
                      {deliverydata.delivery_mode == 1
                        ? "Delivery Address"
                        : "Pickup Address"}
                    </p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {deliverydata.delivery_mode == 0
                        ? ` ${deliverydata.address}, ${deliverydata.city} - ${deliverydata.pincode} , Ph: ${deliverydata.phone_no}`
                        : ` ${deliverydata.name} , ${deliverydata.address} - ${deliverydata.pincode} , Ph: ${deliverydata.phone_no}`}
                      {/* // {` ${deliverydata.name} , ${deliverydata.address} - ${deliverydata.pincode} , Ph: ${deliverydata.phone_no}`} */}
                    </p>
                  </div>
                </div>
              </div>
            </fieldset>
            {transStatus === "" && deliverydata.delivery_mode == 1 && (
              <CourierDetails couItem={courierDetdata} />
            )}
            {transStatus === "" && deliverydata.delivery_mode == 0 && (
              <PickUpDetails PicUpItem={pickupDdata} />
            )}
          </>
        )}

        {preorderdataD?.length > 0 &&
          // ((
          deliverydata.delivery_mode == 1 && (
            // &&
            // courierDetdata.length > 0 &&
            // courierDetdata.map((er) => er.delivery_status === 2).length !=
            //   courierDetdata.length) ||
            // (deliverydata.delivery_mode == 0 &&
            //   pickupDdata.length > 0 &&
            //   pickupDdata.map((er) => er.delivery_status === 2).length !=
            //     pickupDdata.length))
            <div className="row mt-3">
              <div className="col-lg-12 col-md-12 ">
                <fieldset>
                  <legend className="w-auto">
                    Pre-Order Books in this Set
                  </legend>
                  <div className={`row`}>
                    {preorderdataD?.map((et) => (
                      <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 ">
                        <CardTemplate
                          items={et}
                          toggleWish={addWishList}
                          handleSubmitCart={() => handleCartPage(et.id)}
                        />
                      </div>
                    ))}
                  </div>
                  <div className="row">
                    <PaginationTop10
                      totCount={Array.from({
                        length: Math.ceil(
                          totalPreOrderD.length / BooksPerPageforWidgets
                        ),
                      })}
                      currentPage={booksetIndex}
                      onPageChange={setBooksetIndex}
                      hPrev={handlePrev_bookset}
                      hNext={handleNext_bookset}
                    />
                  </div>
                </fieldset>
              </div>
            </div>
          )}
        {transStatus === 0 && (
          <div className="col-md-12 mt-3">
            <div className="form-check form-check-inline" id="Verifycheckbox">
              <input
                ref={txtadVerifyHere}
                className="form-check-input mt-0"
                type="checkbox"
                id="Verify"
                name="Verify"
                onChange={handleChange}
                checked={list.Verify === true ? true : false}
                value="Yes"
              />
              <label className="LablePrivacyText" htmlFor="Verify">
                I hereby certify that the above information are true and correct
                to the best of my knowledge and belief.
                <a
                  className="LablePrivacy align-baseline"
                 href={"/BooksTermsAndCondition"}
                >
                  Terms and Conditions
                </a>
              </label>
            </div>
          </div>
        )}

        {listErrors.Verify && (
          <span className="errors align-top ms-3">{listErrors.Verify}</span>
        )}
        {transStatus === 0 && (
          <div className="row mx-0 mt-3 mb-2">
            <div className="col-md-6 col-12 ps-0"></div>
            <div className="col-md-6 col-12 ListBtn px-0">
              <ul class="List-Button">
                <li class="ListBtnItems">
                  <Link
                    to={"javascript:void(0)"}
                    onClick={
                      tabLabel == 1 ? navigateToPreviousScreen : navigatebooks
                    }
                    className="secondaryButton me-0 px-0"
                    variant="secondary"
                  >
                    {tabLabel == 1
                      ? "Back to Transaction History"
                      : "Back to View All Books"}
                  </Link>
                </li>
                <li class="ListBtnItems">
                  <Link
                    onClick={handlesubmit}
                    to="javascript:void(0)"
                    className="primaryButton "
                  >
                    Proceed To Payment Gateway
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        )}
        {isPaymentLoading && (
          <Dialog open={isPaymentLoading}>
            <DialogContent>
              <div style={{ margin: "15px" }}>
                <p> We are processing your payment. Please wait...</p>
              </div>
            </DialogContent>
          </Dialog>
        )}
      </div>
    </>
  );
}
